<script>
import Layout from '@layouts/main.vue'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

export default {
  page: {
    title: 'Wallabies | Jump forward',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      username: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
    }
  },
  computed: {
    isLocalDevApi() {
      return (
        !!process.env.VUE_APP_API_URL &&
        process.env.VUE_APP_API_URL.includes('localhost')
      )
    },
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null

      return this.logIn({
        username: this.username,
        password: this.password,
      })
        .then((token) => {
          this.tryingToLogIn = false
          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = error
        })
    },
  },
}
</script>

<template>
  <Layout :class="$style.main">
    <v-img
      :alt="$t('logoAlt')"
      class="shrink mr-2"
      contain
      src="@assets/images/logo.png"
      transition="scale-transition"
      width="140"
    />
    <v-sheet color="white" elevation="1" :class="$style.loginPanel">
      <form :class="$style.form" @submit.prevent="tryToLogIn">
        <BaseInputText
          v-model="username"
          name="username"
          :placeholder="
            isLocalDevApi ? 'use admin for local api' : $t('login.email')
          "
        />
        <BaseInputText
          v-model="password"
          name="password"
          type="password"
          :placeholder="
            isLocalDevApi ? 'use password for local api' : $t('login.password')
          "
        />
        <BaseButton :disabled="tryingToLogIn" type="submit">
          <BaseIcon v-if="tryingToLogIn" name="sync" spin />
          <span v-else>
            Log in
          </span>
        </BaseButton>
        <p v-if="authError">
          {{ $t('login.error') }}
        </p>
      </form>
    </v-sheet>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.loginPanel {
  width: 100%;
  padding: 15px;
  margin-top: 1rem;

  @media screen and (min-width: 768px) {
    max-width: 23rem;
  }
}

.form {
  text-align: center;
}

.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-left: 0;
  background-color: $color-primary;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}
</style>
